export default __webpack_public_path__ + "static/media/leaf7.1ad31a7c.svg";